import React from 'react';
import Title from '../../title';
import $ from "jquery";
import Server from '../../../functions/server';
import Permission from '../../../functions/permission';
import Loading from '../../loading';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import AddEdit from './MasterCard';
import Status from './ChangeJobMasterStatus';
import ViewSpares from  './ViewSpares';
import ViewJob from './ViewJob';
import ViewOperatore from './ViewOperatore';
import { Dropdown } from 'semantic-ui-react';
import ReadCookie from '../../../functions/readcookies';

export default class JobCard extends React.Component {

  state = {
    JobCard: [], order: 'DESC', value: 'expected_date',
    status : 1, mode: 'All', fromDate: this.getFormatedDate(new Date(), 7),
    toDate: this.getFormatedDate(new Date()), branchId: this.getBranch()
  }

  getBranch() {
    let data = (ReadCookie("branch"));
    let branch_id = 0;
    for (var i = 0; i < data.length; i++) {
        branch_id = data[i].branch_id;
    }
    return branch_id;
  }

  componentDidMount() {
    this.getJobCardMaster(this.state.order, this.state.value);
  }

  convertIntoNumber(value) {
    try {
      value = Number(value);
    } catch (error) {
      value = 0;
    }
    return value
  }

  getFormatedDate(dates, interval) {
    if (interval > 0) {
      dates = new Date(dates.getTime() - (interval * 24 * 60 * 60 * 1000));
    }
    let month = dates.getMonth() + 1; let date = dates.getDate();
    month = (month >= 10) ? month : "0" + month;
    date = (date >= 10) ? date : "0" + date;
    let x = dates.getFullYear() + "-" + month + "-" + date;
    if (interval == 7) {
      x = dates.getFullYear() + "-" + month + "-01";
    }
    return x;
  }

  sort(order, value) {
    if (order == "DESC") {
      order = "ASC";
    }
    else {
      order = "DESC";
    }
    this.getJobCardMaster(order, value);
  }

  getJobCardMaster = (order, value) => {
    let context = this;
    let { status, mode, fromDate, toDate, branchId } = this.state;
    context.setState({ load: true, message: 'Getting Job Cards', order, value })
    $.ajax({
        type: 'POST', data: { order, value, status, mode, fromDate, toDate, branchId }, 
        url: Server() + 'Sales/JobCard/get.php',
        success: function (data) {
            try {
                data = JSON.parse(data);
                context.setState({ JobCard: data, load: false })
            } catch (error) {
                context.setState({ load: false })
                alert(error)
            }
        },
        error: function (e) {
            alert('Try again1!!')
            context.setState({ load: false });
        }
    });
  }

  CalculateLaborCharge = (jobs) => {
    let price = 0;
    jobs.map((c) => {
      let total = this.convertIntoNumber(c.tprice);
      price = price + total;
    }) 
    return price;
  }

  makeDecimalPoints(value) {
    value = this.convertIntoNumber(value);
    try {
      value = value.toFixed(2);
    } catch (error) {
      value = 0;
    }
    return value;
  }

  handleChange = name => event => { this.setState({ [name]: event.target.value }); };

  selectMode = (f, { value }) => { this.setState({ "mode": value }) }

  selectStatus = (f, { value }) => { this.setState({ "status": value }) }

  jobCardPrint = (id) => {
    window.location = Server() + 'pdf/jobcard/machinejobcard.php?id='+id;
  }

  viewpdf(status, item) {
    let open = Server() + "pdf/jobcard/quotation?id="+item.id;
    if (status == 2) {
      open = Server() + "pdf/jobcard/invoice?id="+item.id;
    }
    window.open(open);
  }

  render() {
    let { load, message, JobCard, status } = this.state;
    let modeOption = [
      { text: 'All', key: 'All', value: 'All' },
      { text: 'Minor', key: 'Minor', value: 'Minor' },
      { text: 'Semi Major', key: 'Semi Major', value: 'Semi Major' },
      { text: 'Major', key: 'Major', value: 'Major' },
      { text: 'Free Service', key: 'Free Service', value: 'Free Service' },
      { text: 'Warrenty Service', key: 'Warrenty Service', value: 'Warrenty Service' },
      { text: 'Other', key: 'Other', value: 'Other' }
    ]
    let statusOption = [
      { text: 'Process', key: 'Process', value: 1 },
      { text: 'Completed', key: 'Completed', value: 2 },
    ]
    return (
      <div>
        <Title title={'Service'} openDrawer={this.props.openDrawer} menus={this.props.menus} />
        <Loading load={load} message={message} />
        <div style={{margin: '0.5%'}}>
          <div style={{display: 'flex'}}>
            <div  style={{marginLeft: '0.5%'}}>
              <TextField label="From" type="date"
                onChange={(e) => this.setState({fromDate: e.target.value})}
                defaultValue={this.state.fromDate} />
            </div>
            <div  style={{marginLeft: '0.5%'}}>
              <TextField label="To" type="date"
                onChange={(e) => this.setState({toDate: e.target.value})}
                defaultValue={this.state.toDate} />
            </div>

            <div  style={{marginLeft: '0.5%'}}>
              <b>Status</b><br/>
              <Dropdown style={{width: '200px'}} fluid search onChange={this.selectStatus} selection 
                  options={statusOption} value={this.state.status} />
            </div>
            <div  style={{marginLeft: '0.5%'}}>
              <b>Work Type</b><br/>
              <Dropdown style={{width: '200px'}} fluid search onChange={this.selectMode} selection 
                  options={modeOption} value={this.state.mode} />
            </div>
            <div style={{marginLeft: '0.5%'}}>
              <br/>
              <Button onClick={ () => this.getJobCardMaster(this.state.order, this.state.value)}>Submit</Button>
            </div>
            
            <div style={{marginLeft: '0.5%'}}>
              <br/>
              <AddEdit refresh={ () => this.getJobCardMaster(this.state.order, this.state.value)} />
            </div>
          </div>
          <br/>
          <table width="100%" id="table">
            <tr>
              <th id='tableheader' onClick={ () => this.sort(this.state.order, 'id') }>ID#</th>
              <th id='tableheader'>{ status == 1 ? 'Quotation Voucher' : 'Invoice Voucher'}</th>
              <th id='tableheader'>Machine Name</th>
              <th id='tableheader'>Description</th>
              <th id='tableheader'>Customer Name</th>
              <th id='tableheader' onClick={ () => this.sort(this.state.order, 'timestamp') }>In Date</th>
              <th id='tableheader' onClick={ () => this.sort(this.state.order, 'expected_date') }>Expected Date</th>
              <th id='tableheader'>Work Type</th>
              <th id='tableheader'>Status</th>
              <th id='tableheader'>Operator</th>
              <th id='tableheader'>Spares</th>
              <th id='tableheader'>Jobs</th>
              <th id='tableheader'>Spares Value</th>
              <th id='tableheader'>Labor Charge</th>
              <th id='tableheader'>Total</th>
              <th id='tableheader'>Action</th>
            </tr>
            {
              JobCard.map((c) => {
                let jobs = c.job_card;
                let intime = c.timestamp.split(" ")[0];
                return (
                  <tr>
                    <td><u style={{cursor: 'pointer'}} onClick={ () => this.jobCardPrint(c.id)}>{c.id}</u></td>
                    <td onClick={() => this.viewpdf(status, c)}>{ status == 1 ? c.quotation_voucher : c.invoice_voucher}</td>
                    <td>{c.machine}</td>
                    <td>{c.issue}</td>
                    <td>{c.name}</td>
                    <td>{intime.split('-')[2]+"-"+intime.split('-')[1]+"-"+intime.split('-')[0]}</td>
                    <td>{c.expected_date}</td>
                    <td>{c.mode}</td>
                    <td><Status refresh={ () => this.getJobCardMaster(this.state.order, this.state.value)} item={c} /></td>
                    <td><b><ViewOperatore item={c} getJobCardMaster={ () => this.getJobCardMaster(this.state.order, this.state.value)} /></b></td>
                    <td><b><ViewSpares item={c} /></b></td>
                    <td><b><ViewJob item={c} getJobCardMaster={ () => this.getJobCardMaster(this.state.order, this.state.value)} /></b></td>
                    <td><b>{this.makeDecimalPoints(c.spares_value)}</b></td>
                    <td><b>{this.makeDecimalPoints(this.convertIntoNumber(c.job_value))}</b></td>
                    <td><b>{(Number(this.makeDecimalPoints(c.spares_value)) + Number(this.makeDecimalPoints(this.convertIntoNumber(c.job_value))))}</b></td>
                    { c.status != '2' || c.status != 2 ?
                      <td>
                        <center style={{cursor: 'pointer'}}>
                          <b>
                            <AddEdit refresh={ () => this.getJobCardMaster(this.state.order, this.state.value)} item={c} />
                          </b>
                        </center>
                      </td>
                      :
                      <td></td>
                    }
                  </tr>
                )
              })
            }
          </table>
        </div>
      </div>
    );
  }
}